module.exports = window.require("mixins!jquery");